import ContactsNotificationPreference from './components/ContactNotifications/ContactsNotificationPreference';
import styles from './RoleAssignment.module.scss';
import {useElliData} from '../../features/role-assignment/hooks/useElliData';
import {useEffect, useState} from 'react';
import {fetchTokenApi} from './services/fetchToken';

const RoleAssignment: React.FC = () => {
    const { loanId, userId, authCode, error } = useElliData();
    const [authCodeValue, setAuthCodeValue] = useState("");
    const [userValue, setUserValue] = useState("");
    useEffect(() => {

        const authCodeFromHTML = document.getElementById('authCode') as HTMLInputElement;
        const userIdFromHTML = document.getElementById('user') as HTMLInputElement;

        const handleInputChange = (event: Event) => {
            const target = event.target as HTMLInputElement;
            if (target.id === 'authCode') {
                setAuthCodeValue(target.value);
            }
            if (target.id === 'user') {
                setUserValue(target.value);
            }
        };

        if (authCodeFromHTML) {
            authCodeFromHTML.addEventListener('input', handleInputChange);
        }
        if (userIdFromHTML) {
            userIdFromHTML.addEventListener('input', handleInputChange);
        }

        return () => {
            if (authCodeFromHTML) {
                authCodeFromHTML.removeEventListener('input', handleInputChange);
            }
            if (userIdFromHTML) {
                userIdFromHTML.removeEventListener('input', handleInputChange);
            }
        };
    }, []);
    useEffect(() => {
        console.log(authCodeValue,"authCodeValue");
        console.log(userValue,"userValue");
        const fetchToken = async () => {
            if (authCode) {
                try {
                    const tokenResponse = await fetchTokenApi(authCode);
                    localStorage.setItem("access_token", tokenResponse.access_token)
                    return tokenResponse.access_token;
                } catch (error: any) {
                    // updateErrorMessage(ERROR_MESSAGE, error ? error.response ? error.response.data ? error.response.data.errorCode : 400 : 400 : 400, ERROR_DESCRIPTION);
                    console.error('Error fetching token:', error);
                }
            }
        };
        fetchToken();
    }, [authCode]);
    if (error) {
        return <div>Error: {error}</div>;
    }

    return (
        <div className={styles.page}>
            <input type="hidden" id="authCode" data-testid="authCode"/>
            <input type="hidden" id="user" data-testid="user"/>
            <ContactsNotificationPreference loanId={loanId} userId={userId} authCode={authCode} />
        </div>
    );
};

export default RoleAssignment;
